module.exports = __webpack_public_path__ + "img/t2-c13.694b0f51.png";